<template>
  <v-icon
    :color="statusColor"
    :class="statusClass"
    small
  >
    {{ statusIcon }}
  </v-icon>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      required: true, // 'online', 'offline', 'suspend'
      validator: val => ['online', 'offline', 'suspend'].includes(val)
    }
  },
  computed: {
    statusIcon() {
      switch(this.status) {
        case 'online': return 'mdi-wifi';
        case 'offline': return 'mdi-wifi-off';
        case 'suspend': return 'mdi-wifi-off';
      }
    },
    statusColor() {
      switch(this.status) {
        case 'online': return 'green';
        case 'offline': return 'red';
        case 'suspend': return 'orange';
      }
    },
    statusClass() {
      return this.status === 'online' ? 'blink' : '';
    }
  }
};
</script>

<style scoped>
.blink {
  animation: blink 1s infinite;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
}
</style>
